/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_ParcelsInputs */

const cs_property_registry_parcels = /** @type {(inputs: Property_Registry_ParcelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcely`)
};

const en_property_registry_parcels = /** @type {(inputs: Property_Registry_ParcelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcels`)
};

/**
* | output |
* | --- |
* | "Parcels" |
*
* @param {Property_Registry_ParcelsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_parcels = /** @type {((inputs?: Property_Registry_ParcelsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_ParcelsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_parcels(inputs)
	return cs_property_registry_parcels(inputs)
});